import Vue from 'vue'
import VueRouter from 'vue-router'
import LayoutWeb from '@/layout/web'

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch((err) => {});
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/login/register.vue')
  },
  {
    path: '/',
    name: 'index',
    redirect: "/home",
    component: () => import( '../views/index/index.vue'),
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import('@/views/home/home.vue'),
        meta: {
          title: "首页"
        }
      },
      {
        path: "/industry",
        name: "industry",
        component: () => import('@/views/home/industry.vue'),
        meta: {
          title: "产业方案"
        }
      },
      {
        path: "/finance",
        name: "finance",
        component: () => import('@/views/home/finance.vue'),
        meta: {
          title: "供应链金融"
        }
      },
      {
        path: "/product",
        name: "product",
        component: () => import('@/views/home/product.vue'),
        meta: {
          title: "供应链金融"
        }
      },
      {
        path: "/AboutUs",
        name: "AboutUs",
        component: () => import('@/views/home/AboutUs.vue'),
        meta: {
          title: "关于我们"
        }
      },
      {
        path: "/FinancingCalculation",
        name: "FinancingCalculation",
        component: () => import('@/views/home/FinancingCalculation.vue'),
        meta: {
          title: "融资计算"
        }
      },
      {
        path: "/Digital",
        name: "Digital",
        component: () => import('@/views/home/Digital.vue'),
        meta: {
          title: "数字科技"
        }
      }
    ]
  },
  {
    path: '/user',
    component: LayoutWeb,
    redirect: '/user/base',
    hidden: true,
    children: [
      {
        path: 'base',
        component: () => import('@/views/user/base/index'),
        meta: { title: '基本信息' }
      },
      {
        path: 'safety',
        component: () => import('@/views/user/safety/index'),
        meta: { title: '账户安全' }
      },
      {
        path: 'management',
        component: () => import('@/views/user/management/index'),
        meta: { title: '资产管理' }
      },
      {
        path: 'approve',
        component: () => import('@/views/user/approve/index'),
        meta: { title: '认证中心' }
      },
      {
        path: 'disburse',
        component: () => import('@/views/user/disburse/index'),
        meta: { title: '我要支用' }
      },
      {
        path: 'use',
        component: () => import('@/views/user/disburse/use'),
        meta: { title: '支用表单' },
        hidden: true
      },
      {
        path: 'quota',
        component: () => import('@/views/user/disburse/quota'),
        meta: { title: '申请贷款' },
        hidden: true
      },
      {
        path: 'quotaDetails/:id',
        component: () => import('@/views/user/disburse/quotaDetails'),
        meta: { title: '授信申请详情' }
      },
      {
        path: 'myLoaned',
        component: () => import('@/views/user/myLoaned/list'),
        meta: { title: '我的贷款' }
      },
      {
        path: 'loanDetails/:id',
        component: () => import('@/views/user/myLoaned/loanDetails'),
        meta: { title: '贷款详情' }
      },
      {
        path: 'repay/:id',
        component: () => import('@/views/user/myLoaned/repay'),
        meta: { title: '提前还款' }
      },
      {
        path: 'repayment',
        component: () => import('@/views/user/repayment/list'),
        meta: { title: '还款明细' }
      },
      {
        path: 'signature',
        component: () => import('@/views/user/signature'),
        meta: { title: '签章认证' }
      }
    ]
  },
]
const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    routes: routes
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
